export enum Period {
    MONTHLY = 'monthly',
    ANNUALLY = 'annually'
}

export enum Plan {
    FREE = 'free',
    BASIC = 'basic',
    PRO = 'pro',
    OEM = 'oem'
}

export enum Feature {
    DATABASE_EXPLORER = 'database_explorer',
    DATABASE_API = 'database_api',
    VULNERABILITY_ASSESSMENT = 'vulnerability_assessment',
    ALERTS = 'alerts',
    VULNERS_MCP = 'vulners_mcp',
    DATASET_EXPORT = 'dataset_export',
    CVE_FUSION = 'cve_fusion',
    VULNERS_EXPLOITS = 'vulners_exploits',
    PARTNER_INTEGRATION_SUITE = 'partner_integration_suite'
}
